import { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { 
  Share2, 
  Download, 
  Copy, 
  Check,
  Coins,
  Users,
  TrendingUp,
  Shield,
  Globe,
  Sparkles,
  X
} from 'lucide-react';
import { toast } from 'sonner';

// Social media icons
const FacebookIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const XIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export default function ShareableAd({ onClose }) {
  const [copied, setCopied] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(0);
  
  const baseUrl = window.location.origin;
  
  const adTemplates = [
    {
      id: 'main',
      headline: "Save Together, Grow Together",
      subheadline: "Join the Global Susu Movement",
      description: "Start saving with as little as $0.10. Earn interest. Build wealth with friends worldwide.",
      hashtags: "#SusuMoney #CommunitySavings #FinancialFreedom #SaveTogether #GlobalSavings",
      gradient: "from-indigo-600 via-purple-600 to-pink-500",
      emoji: "💰"
    },
    {
      id: 'youth',
      headline: "Your Money, Your Future",
      subheadline: "Savings Made Fun & Social",
      description: "Join 5,000+ young savers building wealth together. Start your journey today!",
      hashtags: "#GenZFinance #YoungSavers #MoneyGoals #FinancialLiteracy #SusuMoney",
      gradient: "from-amber-500 via-orange-500 to-red-500",
      emoji: "🚀"
    },
    {
      id: 'community',
      headline: "Stronger Together",
      subheadline: "Traditional Savings, Modern Tech",
      description: "The ancient art of community savings, reimagined for the digital age. Join us!",
      hashtags: "#CommunityFirst #TraditionMeetsInnovation #AfricanFintech #SusuMoney",
      gradient: "from-green-500 via-emerald-500 to-teal-500",
      emoji: "🌍"
    }
  ];

  const currentAd = adTemplates[selectedTemplate];

  const shareText = `${currentAd.emoji} ${currentAd.headline}!\n\n${currentAd.description}\n\n✨ Join FREE: ${baseUrl}\n\n${currentAd.hashtags}`;
  const encodedText = encodeURIComponent(shareText);
  const encodedUrl = encodeURIComponent(baseUrl);

  const socialPlatforms = [
    {
      name: 'Facebook',
      icon: FacebookIcon,
      color: 'bg-[#1877F2]',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`
    },
    {
      name: 'X',
      icon: XIcon,
      color: 'bg-black',
      url: `https://twitter.com/intent/tweet?text=${encodedText}`
    },
    {
      name: 'WhatsApp',
      icon: WhatsAppIcon,
      color: 'bg-[#25D366]',
      url: `https://api.whatsapp.com/send?text=${encodedText}`
    },
    {
      name: 'Instagram',
      icon: InstagramIcon,
      color: 'bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]',
      copyOnly: true
    },
    {
      name: 'TikTok',
      icon: TikTokIcon,
      color: 'bg-black',
      copyOnly: true
    }
  ];

  const copyAdText = async () => {
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      toast.success('Ad copy copied! Paste it on your favorite platform');
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      toast.error('Failed to copy');
    }
  };

  const handleShare = (platform) => {
    if (platform.copyOnly) {
      copyAdText();
      toast.success(`Ad copied! Now paste it on ${platform.name}`);
    } else {
      // Try to open share window
      const shareWindow = window.open(platform.url, '_blank', 'width=600,height=500,scrollbars=yes');
      
      // Check if popup was blocked
      if (!shareWindow || shareWindow.closed || typeof shareWindow.closed === 'undefined') {
        toast.info(`Pop-up blocked! Copy the ad text and share manually`, {
          action: {
            label: 'Copy',
            onClick: () => copyAdText()
          },
          duration: 5000
        });
        copyAdText();
      } else {
        toast.success(`Opening ${platform.name}...`);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 overflow-y-auto">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="bg-white rounded-3xl max-w-2xl w-full shadow-2xl overflow-hidden my-4"
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-stone-200">
          <h2 className="text-xl font-bold text-stone-900 flex items-center">
            <Sparkles className="w-5 h-5 mr-2 text-amber-500" />
            Share Our Ad
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-stone-100 rounded-full transition-colors"
            data-testid="close-ad-modal"
          >
            <X className="w-5 h-5 text-stone-500" />
          </button>
        </div>

        {/* Template Selector */}
        <div className="p-4 bg-stone-50 border-b border-stone-200">
          <p className="text-sm text-stone-600 mb-2">Choose Ad Style:</p>
          <div className="flex gap-2">
            {adTemplates.map((template, index) => (
              <button
                key={template.id}
                onClick={() => setSelectedTemplate(index)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  selectedTemplate === index
                    ? `bg-gradient-to-r ${template.gradient} text-white shadow-lg`
                    : 'bg-white border border-stone-200 text-stone-600 hover:border-stone-300'
                }`}
                data-testid={`ad-template-${template.id}`}
              >
                {template.emoji} {template.id === 'main' ? 'Classic' : template.id === 'youth' ? 'Youth' : 'Community'}
              </button>
            ))}
          </div>
        </div>

        {/* Ad Preview */}
        <div className="p-6">
          <p className="text-sm text-stone-500 mb-3 text-center">Ad Preview</p>
          
          <motion.div
            key={selectedTemplate}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className={`bg-gradient-to-br ${currentAd.gradient} rounded-2xl p-6 text-white shadow-xl`}
          >
            {/* Logo */}
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center mr-3">
                <Coins className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold">Susu Money</span>
            </div>

            {/* Main Content */}
            <div className="mb-6">
              <h3 className="text-3xl font-bold mb-2">{currentAd.headline}</h3>
              <p className="text-lg text-white/90 mb-3">{currentAd.subheadline}</p>
              <p className="text-white/80">{currentAd.description}</p>
            </div>

            {/* Features */}
            <div className="grid grid-cols-2 gap-3 mb-6">
              <div className="bg-white/10 rounded-xl p-3 flex items-center">
                <Users className="w-5 h-5 mr-2" />
                <span className="text-sm">5,000+ Savers</span>
              </div>
              <div className="bg-white/10 rounded-xl p-3 flex items-center">
                <Globe className="w-5 h-5 mr-2" />
                <span className="text-sm">50+ Countries</span>
              </div>
              <div className="bg-white/10 rounded-xl p-3 flex items-center">
                <TrendingUp className="w-5 h-5 mr-2" />
                <span className="text-sm">Earn Interest</span>
              </div>
              <div className="bg-white/10 rounded-xl p-3 flex items-center">
                <Shield className="w-5 h-5 mr-2" />
                <span className="text-sm">100% Secure</span>
              </div>
            </div>

            {/* CTA */}
            <div className="bg-white rounded-xl p-4 text-center">
              <p className="text-stone-900 font-bold text-lg mb-1">Join FREE Today!</p>
              <p className="text-indigo-600 font-medium">{baseUrl}</p>
            </div>

            {/* Hashtags */}
            <p className="text-xs text-white/60 mt-4 text-center">
              {currentAd.hashtags}
            </p>
          </motion.div>
        </div>

        {/* Share Buttons */}
        <div className="p-6 pt-0">
          <p className="text-sm text-stone-600 mb-3 text-center">Share this ad on:</p>
          
          <div className="flex justify-center gap-3 mb-4">
            {socialPlatforms.map((platform) => (
              <motion.button
                key={platform.name}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleShare(platform)}
                className={`${platform.color} text-white p-4 rounded-xl shadow-lg hover:shadow-xl transition-all`}
                data-testid={`share-ad-${platform.name.toLowerCase()}`}
                title={`Share on ${platform.name}`}
              >
                <platform.icon />
              </motion.button>
            ))}
          </div>

          {/* Copy Button */}
          <Button
            onClick={copyAdText}
            variant="outline"
            className="w-full rounded-xl py-6"
            data-testid="copy-ad-btn"
          >
            {copied ? (
              <>
                <Check className="w-5 h-5 mr-2 text-green-600" />
                Copied!
              </>
            ) : (
              <>
                <Copy className="w-5 h-5 mr-2" />
                Copy Ad Text
              </>
            )}
          </Button>

          <p className="text-xs text-stone-400 text-center mt-3">
            Tip: For Instagram & TikTok, copy the ad text and paste it in your caption or bio
          </p>
        </div>
      </motion.div>
    </div>
  );
}
